(() => {
  function openTargetDetails(hash: string): void {
    if (!hash.startsWith('#')) return;
    const target = document.getElementById(hash.slice(1));
    if (target instanceof HTMLDetailsElement) target.open = true;
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest<HTMLAnchorElement>('a[href^="#"]');
    if (link) openTargetDetails(link.hash);
  });

  window.addEventListener('hashchange', () => openTargetDetails(window.location.hash));
  openTargetDetails(window.location.hash);
})();
